import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { MaximiseNoteIcon, MinimisedNoteIcon } from "../../assets/constants";

const MinimisedNoteContent = ({
  customNotesValue,
  openMaximiseHandler,
  showCancelConfirmationModalHandler,
}) => {
  return (
    <Box
      display="flex"
      //   position="absolute"
      //   bottom="20px"
      //   right="40px"
      //   zIndex="9999"
      border="1px solid #EBEBEB"
      borderRadius="8px"
      bgcolor="#FFF"
      boxShadow="8px 10px 20px 0px rgba(0, 0, 0, 0.10)"
      padding="16px"
      width="409px"
      gap="12px"
      alignItems="flex-start"
    >
      <Box bgcolor="rgba(254, 205, 170, 0.19)" borderRadius="7px" padding="6px">
        <MinimisedNoteIcon />
      </Box>
      <Stack width="100%" gap="5px" alignItems="flex-start">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          onClick={openMaximiseHandler}
        >
          <Typography variant="subtitle1" color="secondary" fontSize="1.8rem">
            Note minimized
          </Typography>
          <Button
            size="small"
            startIcon={<MaximiseNoteIcon />}
            variant="text"
            sx={{ textTransform: "capitalize" }}
          >
            Maximize
          </Button>
        </Box>
        <Typography
          variant="body2"
          color="rgba(0, 0, 0, 0.38)"
          paddingBottom="4px"
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {customNotesValue}
        </Typography>
        <Box
          bgcolor="rgba(179, 30, 30, 0.05)"
          padding="2px 10px"
          borderRadius="4px"
        >
          <Button
            size="small"
            variant="text"
            sx={{
              textTransform: "capitalize",
              color: "#D32F2F",
              //   ":hover": {
              //     background: "none",
              //   },
            }}
            onClick={showCancelConfirmationModalHandler}
          >
            Discard & Close
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default MinimisedNoteContent;
